import { Button, type ButtonProps, styled } from '@mui/material';

import { removeTheseProps } from '@/utils';

export type PagesButtonProps = ButtonProps & {
  isActive?: boolean;
};

export const PagesButton = styled(Button, {
  shouldForwardProp: removeTheseProps<PagesButtonProps>('isActive'),
})<PagesButtonProps>(({ isActive, theme }) => ({
  width: 5,
  minWidth: 30,
  height: 30,
  margin: 5,
  padding: 10,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 6,
  border: 'none',
  cursor: isActive ? 'pointer' : 'unset',
  color: isActive ? theme.palette.black.main : '#DDDDDD',
  ':hover': {
    backgroundColor: isActive
      ? theme.palette.white.main
      : theme.palette.gray100.main,
  },
  transition: '200ms',
  borderRadius: 25,
  backgroundColor: 'unset',
  '&:focus': {
    outline: 'none',
  },
}));
